module.exports = __webpack_public_path__ + "static/media/VE.d42cc2f3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/VE.svg
// module id = 2288
// module chunks = 7